export default __webpack_public_path__ + "static/media/logout.fd6a2f4e.svg";